/**
 * @file FullscreenDisplay.js
 * @description This component displays an overlaying fullscreen view for an image or video.
 */

import { useEffect } from 'react';
import styles from './FullscreenDisplay.module.scss';
import { getText } from '../../../i18n';

const FullscreenDisplay = ({
    isFullscreen,
    fullscreenImageUrl,
    mediaType = 'image',
    closeFullscreen,
}) => {
    useEffect(() => {
        if (!isFullscreen) {
            return undefined;
        }

        const handleKeyDown = event => {
            if (event.key === 'Escape') {
                closeFullscreen();
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [closeFullscreen, isFullscreen]);

    if (!isFullscreen) return null;

    const handleContentClick = event => {
        if (event.target === event.currentTarget) {
            closeFullscreen();
        }
    };

    return (
        <div className={styles.fullscreenOverlay}>
            <div
                className={styles.fullscreenContent}
                onClick={handleContentClick}
            >
                <button
                    className={styles.closeButton}
                    onClick={closeFullscreen}
                >
                    <i className="bi bi-x"></i>
                </button>
                {mediaType === 'video' ? (
                    <video
                        src={fullscreenImageUrl}
                        className={styles.fullscreenVideo}
                        controls
                        autoPlay
                        playsInline
                    />
                ) : (
                    <img
                        src={fullscreenImageUrl}
                        alt={getText('msg_bb08d10b00a6')}
                        className={styles.fullscreenImage}
                    />
                )}
            </div>
        </div>
    );
};

export default FullscreenDisplay;
